<template>
  <div>
    <com-dialog title="用户提现" :visible.sync="visible">
      <div>
        <div class="mb-15px">钱包余额: {{ userInfo.wallet || 0 }}元</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-form-item label="提现原因" prop="remark">
            <el-input type="textarea" v-model="ruleForm.remark" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="提现金额" prop="amount">
            <el-input v-model="ruleForm.amount" placeholder=""></el-input>
          </el-form-item>
        </el-form>
        <div class="mt-15px flex justify-end">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" :disabled="disabled"
            >确定</el-button
          >
        </div>
      </div>
    </com-dialog>
    <com-checked-pwd ref="checkedPwd" @confirm="handleConfirm"></com-checked-pwd>
  </div>
</template>

<script>
import { userWithdrawApi } from '@/api/user'

export default {
  data() {
    return {
      visible: false,
      disabled: false,
      ruleForm: {},
      userInfo: {},
      rules: {
        remark: [{ required: true, message: '请输入提现原因', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入提现金额', trigger: 'blur' }]
      }
    }
  },
  methods: {
    open(row) {
      this.userInfo = { ...row }
      this.visible = true
    },
    close() {
      this.visible = false
    },
    submitForm(formName) {
      const that = this
      // eslint-disable-next-line consistent-return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.$refs.checkedPwd.open()
        }
      })
    },
    handleConfirm(val) {
      const params = { ...this.ruleForm, auditPassword: val, userCode: this.userInfo.code }

      userWithdrawApi(params).then((res) => {
        if (res.status === 200) {
          this.$message('操作成功')
          this.$emit('confirm')
          this.close()
        }
      })
    }
  }
}
</script>
